import React from "react";
import MainHeader from "../pop-ups/MainHeader";

const AdminProfile = () => {
  return (
    <div className="dashboard">
      <MainHeader title={"Admin Profile"}>Edit Admin Profile </MainHeader>
      <main>
        <h4>Edit page is in still beta development version .</h4>
        <p>please wait for few months.</p>
        <p>we update this page as soon as possible.</p>
      </main>
    </div>
  );
};

export default AdminProfile;
